import {
  AI_CHATGPT,
  AI_CLAUDE_ICON,
  AI_GEMINI,
  AI_MISTRAL_AI,
  AI_DEEPSEEK_ICON,
  AI_META_ICON,
} from "@/components/atoms/IconSet";
import { IMenuBase } from "@/interfaces/IMenu";

export const AI_MODALS: IMenuBase[] = [
  {
    id: "chatgpt",
    label: "chatgpt",
    icon: AI_CHATGPT(),
  },
  {
    id: "claude",
    label: "claude",
    icon: AI_CLAUDE_ICON(),
  },
  {
    id: "mistral-ai",
    label: "mistral-ai",
    icon: AI_MISTRAL_AI(),
  },
  {
    id: "gemini",
    label: "gemini",
    icon: AI_GEMINI(),
  },
  {
    id: "deepseek",
    label: "deepseek",
    icon: AI_DEEPSEEK_ICON(),
  },
  {
    id: "meta",
    label: "meta",
    icon: AI_META_ICON(),
  },
];
